
import { handlePageToThs } from '../utils/utils';
import { controllerUse } from '../show-controller';
const win: any = window;
const isShare = !win.F10Utils.getBroker() && win.F10Utils.getUrlParams('fromshare');
const isHas = controllerUse('hitNewStock');
// 跳转交易申购页
export const jumpToBuy = (buyCode: string, stockCode: string, marketId: string) => {
    // 分享页面调用下载同花顺方法
    if (isShare) {
        handlePageToThs();
        return;
    }
    if (isHas) {
        win.location.href = 'client.html?action=ymtz^stockcode=' + buyCode + '^webid=2633^listedcode=' + stockCode + '^marketid=' + marketId;
    }
}

// 跳转交易查询申购结果页
export const  jumpToSeeCheck = () => {
    // 分享页面调用下载同花顺方法
    if (isShare) {
        handlePageToThs();
        return;
    }
    if (isHas) {
        const accountType = win.F10Utils.getUrlParams('accounttype');
        // 跳转结果需要根据账号类型，如果为两融账号(rzrq)则使用express=rzrq_apply_query
        if(accountType === 'rzrq'){
            win.location.href = 'client.html?action=ymtz^express=rzrq_apply_query'; 
        }else{
            win.location.href = 'client.html?action=ymtz^express=apply_query';
        }
    }
}

// 跳转详情页
export const jumpToDetail = (buyCode: string, type: string, fid: string, isBond?: boolean) => {
    win.F10Utils.jumpToLink({
        url: `//data.hexin.cn/ipo/sgdetail/code/${buyCode}/btntype/${type}/?fid=${fid}`
    })
}

// 跳转股票/转债盘口协议
export const jumpToPanKou = (stockcode: string, stockname: string, marketid: string ) => {
    // 分享页面调用下载同花顺方法
    if (isShare) {
        handlePageToThs();
        return;
    }
    if (isHas) {
        win.F10Utils.fenshiJump({
            stockcode,
            marketid,
            tabid: '1',
            sourcePage: 'fromWeb',
        })
    }
}

// 跳转股票分时
export const jumpToHQ = (stockcode: string, marketId: string) => {
    // 分享页面调用下载同花顺方法
    if (isShare) {
        handlePageToThs();
        return;
    }
    if (isHas) {
        win.F10Utils.fenshiJump({
            stockcode,
            marketid: marketId,
        })
    }
}

